import { IContentPage } from '../../schema/content/content-management';
import { CakeApiBase } from '../CakeApiBase';

export class ContentManagementApi extends CakeApiBase {
  async getPublicContentPage(pageKey: string) {
    return this.requestManager.get<IContentPage>(`/content/public-page?key=${pageKey}`);
  }
}
